export default "__VITE_ASSET__CIxhKfMU__"